module.exports = __webpack_public_path__ + "img/ez-slot-menu-slot.e45dda28.png";